import { useContext } from 'react';

// components
import { InlineEdit } from 'components/ContentCreator/InlineEdit';
import { InnerHtml } from 'components/InnerHtml/inner-html';

// utils
import { truncateAtWordBoundary } from 'utils/truncate';
import { InteractiveDescriptionContext } from '../context';
import { useTracking as useTracking2 } from 'utils/tracking/track';
import { trackInteractiveDescriptionInfoClick } from 'components/ContentElements/interactive-description/interactive-description';

export function DescriptionDefault() {
  const { isChild, infoText, contentHeadline, isSectionReference } = useContext(
    InteractiveDescriptionContext,
  );

  const { trackClick } = useTracking2();

  return (
    <div className="interactive-description__content large-6">
      {contentHeadline && (
        <InlineEdit previewId="#st_contentHeadline" isSectionReference={isSectionReference}>
          <InnerHtml
            as={isChild ? 'h5' : 'h3'}
            className="h4"
            content={truncateAtWordBoundary(contentHeadline, 75)}
          />
        </InlineEdit>
      )}
      {infoText && (
        <div className="interactive-description__info">
          <button tabIndex={0} onClick={trackInteractiveDescriptionInfoClick(trackClick)}>
            <i className="icon web20-icon web20-icon-info-circle-full" />
          </button>
          <InlineEdit previewId="#st_title" isSectionReference={isSectionReference}>
            <InnerHtml as="span" content={truncateAtWordBoundary(infoText, 50)} />
          </InlineEdit>
        </div>
      )}
    </div>
  );
}
